import React, { SFC } from 'react'

import './display-percentage.scss'

type Props = {
  value: number
  percentClassName?: string
  hidePercentSymbol?: boolean
  className?: string
}

export const DisplayPercentage: SFC<Props> = ({
  value,
  percentClassName = 'display-percentage__percent',
  hidePercentSymbol = false,
  className = '',
}) => (
  <div className={className}>
    {value}
    {!hidePercentSymbol && <span className={percentClassName}>%</span>}
  </div>
)



// WEBPACK FOOTER //
// ./src/app/shared/components/display-percentage/display-percentage.tsx